import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Doctor } from '../../../core/interfaces/doctor.interface';
import {
  LucideAngularModule,
  User as UserIcon,
  Hospital,
  AlertCircleIcon,
  MapPinIcon,
} from 'lucide-angular';
import { SafeMapsComponent } from '../maps/safe-maps.component';
import { DoctorStructureSlotsComponent } from '../doctor-structure-slots/doctor-structure-slots.component';
import { RouterModule } from '@angular/router';
import { CountryStorageService } from '../../../core/services/country.storage.service';
import { Country } from '../../../core/interfaces/doctor.interface';

@Component({
  selector: 'app-card-doctor',
  standalone: true,
  imports: [
    CommonModule,
    LucideAngularModule,
    SafeMapsComponent,
    DoctorStructureSlotsComponent,
    RouterModule,
  ],
  templateUrl: './card-doctor.component.html',
  styleUrls: ['./card-doctor.component.scss'],
})
export class CardDoctorComponent implements OnInit {
  @Input() doctor!: Doctor;
  @Input() showDistance: boolean = true;
  @Input() showSpecialisation: boolean = true;
  @Input() showType: boolean = true;
  @Input() showMap: boolean = true;
  @Input() showSlots: boolean = false;

  selectedCountry: Country | null = null;
  PrefixUrlCountryCode: string = '';

  // Exemple de latitude et longitude pour Paris
  latitude: number = 48.8566;
  longitude: number = 2.3522;

  readonly UserIcon = UserIcon;
  readonly HospitalIcon = Hospital;
  readonly AlertCircleIcon = AlertCircleIcon;
  readonly MapPinIcon = MapPinIcon;

  constructor(private countryStorage: CountryStorageService) {}

  ngOnInit(): void {
    this.countryStorage.country$.subscribe((country) => {
      this.selectedCountry = country;
      this.PrefixUrlCountryCode = `/${this.selectedCountry?.code?.toLowerCase()}`;
    });
  }

  onTakeAppointment(): void {}

  get hasCoordinates(): boolean {
    return (
      this.doctor?.coordonate?.latitude !== null &&
      this.doctor?.coordonate?.longitude !== null &&
      this.doctor?.coordonate?.latitude !== undefined &&
      this.doctor?.coordonate?.longitude !== undefined
    );
  }

  roundDistance(distance: number): string {
    if (distance < 999) {
      return `${Math.round(distance / 50) * 50} m`;
    } else {
      return `${Math.round(distance / 100) / 10} km`;
    }
  }

}
